import type { ReactNode } from 'react';

import styles from './PageHeader.module.css';

export interface PageHeaderProps {
  title: ReactNode;
  lede?: ReactNode;
  /** Above the title, e.g. a link back; routing is the caller's. */
  back?: ReactNode;
  /** Opposite `back`, top right, e.g. a delete button. */
  corner?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({ title, lede, back, corner, actions, className }: PageHeaderProps) {
  return (
    <div className={[styles.header, className].filter(Boolean).join(' ')}>
      {back || corner ? (
        <div className={styles.top}>
          {back ? <div className={styles.back}>{back}</div> : <span />}
          {corner}
        </div>
      ) : null}
      <div className={styles.row}>
        <div className={styles.text}>
          <h1 className={styles.title}>{title}</h1>
          {lede ? <p className={styles.lede}>{lede}</p> : null}
        </div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
    </div>
  );
}
